module.exports = __webpack_public_path__ + "img/twitter.24742ea4.svg";